import React, { FC } from 'react'

import { Stack, Typography, useTheme } from '@mui/material'

import { DailyStatsCardProps } from '../types'

export const DailyStatItem: FC<DailyStatsCardProps> = ({ title, description }) => {
  const { spacing, palette } = useTheme()

  return (
    <Stack direction={'column'} spacing={1} alignItems={'center'} justifyContent={'center'}>
      <Typography
        variant={'body1'}
        fontSize={{ xs: 10, md: 12 }}
        fontWeight={500}
        color={palette.grey[700]}
      >
        {title}
      </Typography>

      <Typography mt={spacing(0.25)} variant={'h4'} fontSize={{ xs: 14, md: 20 }}>
        {description}
      </Typography>
    </Stack>
  )
}
